var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vSelect',{staticClass:"st-select",attrs:{"placeholder":"Select place","label":"constituency","options":_vm.newOptions},on:{"input":_vm.oninput}})}
var staticRenderFns = []

export { render, staticRenderFns }